// extracted by mini-css-extract-plugin
export default {"column":"ChunkCreation-modules__column__OOkb8","columnElement":"ChunkCreation-modules__columnElement__Du43F","columnTitle":"ChunkCreation-modules__columnTitle__Rqn9y"};